export default __webpack_public_path__ + "static/valuation-banner-1600-778873d9455bd4e33e85a0cbea38eb31.jpg";